// Mobile Safari/Chrome keep layout viewport (100vh / 100svh) at the pre-keyboard
// size. The visual viewport shrinks instead, so a column sized to svh sits under
// the keyboard and overflow:hidden on <main> makes the composer and list
// pagination unreachable. Drive mobile pane height from visualViewport.

export const APP_VISUAL_HEIGHT_VAR = '--app-visual-height';
export const MOBILE_CHAT_CHROME_PX = 90;
export const KEYBOARD_OPEN_THRESHOLD_PX = 120;

export function readVisualViewportHeight(win = window) {
  const vv = win.visualViewport;
  if (vv && typeof vv.height === 'number' && vv.height > 0) {
    return vv.height;
  }
  return win.innerHeight;
}

export function isVisualKeyboardOpen(win = window, thresholdPx = KEYBOARD_OPEN_THRESHOLD_PX) {
  const vv = win.visualViewport;
  if (!vv || typeof vv.height !== 'number') return false;
  return win.innerHeight - vv.height > thresholdPx;
}

export function mobileChatPaneHeight() {
  return `calc(var(${APP_VISUAL_HEIGHT_VAR}, 100dvh) - ${MOBILE_CHAT_CHROME_PX}px)`;
}

export function syncVisualViewportHeight(win = window) {
  const h = readVisualViewportHeight(win);
  win.document.documentElement.style.setProperty(APP_VISUAL_HEIGHT_VAR, `${Math.round(h)}px`);
  return h;
}

export function subscribeVisualViewport(onChange, win = window) {
  const handler = () => {
    const h = syncVisualViewportHeight(win);
    if (onChange) onChange(h);
  };
  handler();
  const vv = win.visualViewport;
  if (vv) {
    vv.addEventListener('resize', handler);
    vv.addEventListener('scroll', handler);
  }
  win.addEventListener('resize', handler);
  return () => {
    if (vv) {
      vv.removeEventListener('resize', handler);
      vv.removeEventListener('scroll', handler);
    }
    win.removeEventListener('resize', handler);
  };
}
